import axios from 'axios';
import type { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import { ElMessage } from 'element-plus';
import router from '@/router';

const request: AxiosInstance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' 
    ? 'https://accountapi.emoera.com/api' 
    : (process.env.VUE_APP_API_BASE_URL || '/api'),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器：添加 JWT token
request.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    
    const token = localStorage.getItem('token');
    if (token && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    // 确保POST请求的Content-Type正确设置
    if (config.method?.toLowerCase() === 'post' && config.headers) {
      config.headers['Content-Type'] = 'application/json';
    }
    
    return config;
  },
  (error) => {
    console.error('请求拦截器错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response: AxiosResponse) => {
    
    const res = response.data;
    

    
    // 检查业务状态码
    if (res.code !== 200) {
      console.error('请求失败，状态码:', res.code, '消息:', res.message, '完整响应:', res);
      return Promise.reject(new Error(res.message || '请求失败'));
    }
    
    return res;
  },
  (error) => {
    // 处理 HTTP 错误
    console.error('请求错误:', error);
    console.error('错误响应:', error.response);
    console.error('错误数据:', error.response?.data);
    
    let message = '请求失败';
    let redirectPath: string | null = null;

    if (error.response) {
      console.error('HTTP状态码:', error.response.status);
      console.error('响应数据:', error.response.data);
      
      switch (error.response.status) {
        case 400:
          message = error.response.data?.message || '请求参数错误';
          break;
        case 401: {
          message = '未授权,请重新登录';
          // 清除失效的token
          localStorage.removeItem('token');
          
          // 保存当前完整URL(包括查询参数)用于登录后跳转
          redirectPath = window.location.pathname + window.location.search;
          
          // 如果是OAuth/OIDC授权页面,需要保留所有参数
          if (window.location.pathname.startsWith('/oauth/authorize') || 
              window.location.pathname.startsWith('/api/oauth2/authorize')) {
            redirectPath = window.location.href.replace(window.location.origin, '');
          }
          
          // 跳转到登录页面
          router.replace({
            path: '/login',
            query: { redirect: redirectPath }
          });
          break;
        }
        case 403:
          message = '没有权限执行此操作';
          break;
        case 500:
          message = '服务器错误';
          break;
        default:
          message = error.response.data?.message || '请求失败';
      }
    } else if (error.request) {
      console.error('网络错误，没有收到响应:', error.request);
      message = '网络连接失败，请检查网络';
    } else {
      console.error('请求配置错误:', error.message);
      message = '请求配置错误';
    }

    ElMessage.error(message);
    return Promise.reject(error);
  }
);

export default request;